import Button from '@mui/material/Button';
import classNames from 'classnames';
import { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { resetProductSelection } from '/@/store/catalog/actions';
import { useCatalogConfig } from '/@/store/catalog/apiProviders';
import type { Brand } from '/@/types/catalog';
import { reverse } from '/@/utils/router';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

const BrandDisplay = ({ brand, isLogin, children }: { brand: Brand; isLogin: boolean; children: React.ReactNode }) => {
    const dispatch = useDispatch();
    const { data: config } = useCatalogConfig({ brand: brand.id });
    const history = useNavigate();

    // This is to avoid display de label "Refuge" which makes no sense. Instead it displays the brand name.
    const brandLabel = brand.name === 'Refúgio Max' ? 'Refúgio Max' : settings.enums.brandTypes[brand.type].label;

    const handleClick = (e) => {
        dispatch(resetProductSelection());
        const type = e.type;
        const slug = e.slug;
        history(
            reverse('catalog.ProductSelection', {
                params: {
                    type,
                    slug,
                    internal: 'catalog',
                },
            })
        );
    };

    return (
        <Fragment>
            <div className={classNames(styles.loginBrand, !isLogin && styles.rowDisplay)}>
                <div className={styles.logoContainer}>
                    <img onClick={() => handleClick(brand)} className={styles.circleLogo} src={brand.logo} />
                </div>
                {children}
                <div className={!isLogin && styles.text}>
                    <Title
                        color={isLogin && 'light'}
                        className={styles.cropLogin}
                        theme={!isLogin && settings.app.theme}
                        bolder={!isLogin}
                    >
                        {brandLabel}
                    </Title>
                    {!isLogin && (
                        <div>
                            <Title color='light' className={classNames(styles.description, styles.cropLogin)}>
                                {config && _(config.listDescription)}
                            </Title>
                            <Button variant='contained' onClick={() => handleClick(brand)} fullWidth sx={{ my: 2 }}>
                                {_('Acceder')}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </Fragment>
    );
};

export default BrandDisplay;
